export const openGraphConstants = {
  description: 'Your home for daily research insights from industry professionals. Ask questions, get answers and share your knowledge on the Learners app.',
  img: 'https://data.joinlearners.com/images/new-cover-learners.png',
}
